/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type RunErrorSchemaCode = typeof RunErrorSchemaCode[keyof typeof RunErrorSchemaCode];


export const RunErrorSchemaCode = {
  opensearch_unavailable: 'opensearch_unavailable',
  timed_out: 'timed_out',
  invalid_definition: 'invalid_definition',
  internal: 'internal',
} as const;
